// PageHeader — En-tête de page avec bandeau gradient, icône et titre principal.
// Affiché au-dessus des widgets, en dehors de tout conteneur blanc.
// Utilise les couleurs de la sidebar (gray-800 → gray-700) pour s'inscrire dans le chrome
// de l'application sans concurrencer les couleurs d'action (indigo).

// Import React
import React from 'react';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// --- Interface ---

interface PageHeaderProps {
	icon: IconDefinition;
	title: string;
	// Sous-titre optionnel affiché sous le titre principal
	subtitle?: string;
	// Classes CSS additionnelles sur le conteneur (ex: "!max-w-full")
	className?: string;
}

// --- Composant ---

const PageHeader: React.FC<PageHeaderProps> = ({
	icon,
	title,
	subtitle,
	className,
}) => (
	<div
		className={`max-w-6xl mx-auto bg-gradient-to-r from-gray-800 to-gray-500 rounded-xl px-6 py-4 flex items-center gap-4 shadow-md ${className ?? ''}`}
	>
		<FontAwesomeIcon
			icon={icon}
			className={`${subtitle ? 'w-9 h-9' : 'w-7 h-7'} text-white opacity-90 shrink-0`}
		/>
		<div className="flex flex-col">
			<h1 className="text-2xl font-bold text-white tracking-wide leading-tight">
				{title}
			</h1>
			{subtitle && (
				<span className="text-gray-300 text-sm mt-0.5">{subtitle}</span>
			)}
		</div>
	</div>
);

export default PageHeader;
